// extracted by mini-css-extract-plugin
module.exports = {"centered":"Section_centered__8fG3A","Content":"Section_Content__SgRf7"};